/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_no_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No passkeys registered yet`)
};

const zh_hans1_settings_no_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未注册通行密钥`)
};

const zh_hant1_settings_no_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未註冊通行金鑰`)
};

const fr_settings_no_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune passkey enregistrée`)
};

const de_settings_no_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Passkeys registriert`)
};

const ja_settings_no_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだパスキーが登録されていません`)
};

const ko_settings_no_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록된 패스키가 없습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_no_passkeys = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_no_passkeys(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_no_passkeys", locale)
	if (locale === "en") return en_settings_no_passkeys(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_no_passkeys(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_no_passkeys(inputs)
	if (locale === "fr") return fr_settings_no_passkeys(inputs)
	if (locale === "de") return de_settings_no_passkeys(inputs)
	if (locale === "ja") return ja_settings_no_passkeys(inputs)
	return ko_settings_no_passkeys(inputs)
};